module.exports = __webpack_public_path__ + "static/media/img-cover-01.4b65e582.png";